export default __webpack_public_path__ + "69831179f6fc6e1a5c5b16bd385b02e1.png";